import React from "react";
import useInView from "../hooks/useInView";

function About() {
    const [sectionRef, isInView] = useInView();

    return (
        <section className="py-16 bg-gray-50">
            <div
                ref={sectionRef}
                className={`max-w-7xl mx-auto px-4 fade-in-section ${
                    isInView ? "is-visible" : ""
                }`}
            >
                <h2 className="text-4xl font-bold text-center mb-8">
                    Hakkımızda
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div>
                        <img
                            src="/images/yacht-bg-5.jpg"
                            alt="About Us"
                            className="rounded-lg shadow-lg w-[600px] h-[250px] object-cover"
                        />
                    </div>
                    <div className="flex flex-col justify-center">
                        <p className="text-gray-600 mb-4">
                            Lüks yat kiralama sektöründe olan deneyimimizle,
                            müşterilerimize unutulmaz deniz deneyimleri yaşatmak
                            için özenle seçilmiş yat filomuz ve profesyonel
                            ekibimizle hizmetinizdeyiz.
                        </p>
                        <p className="text-gray-600 mb-4">
                            Müşterilerimize unutulmaz deniz deneyimleri yaşatmak
                            için özenle seçilmiş yat filomuz ve profesyonel
                            ekibimizle hizmetinizdeyiz.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;
